<h1>
  <span class="material-symbols-outlined">
    {{this.icon}}
  </span>
  <span>
    {{this.title }}
  </span>
</h1>